import { useEffect, useState } from "react";
import { handleNewSecureChatMessages, mapSecureChatHistoryToConversationModel, mapSecureChatParticipantToConversationCardModel, mapSecureChatSchedulesToConversationMessage } from "../../models/conversations";
import { UpdateFalkonWebSocket, UpdateFalkonWebSocketConnection, UpdateHistory, UpdateSecureChatConversations, UpdateSecureScheduleMessages } from "../../actions";
import store from "../../stores/app-store";

let MAX_RETRIES = 5;

let RETRY_COUNT = 0;

const ConnectWebSocket = (dispatch, url) => {

    let existingSocket = store.getState().FalkonWebSocket;

    if (existingSocket && (existingSocket.readyState === WebSocket.OPEN || existingSocket.readyState === WebSocket.CONNECTING)) {  // Prevent duplicate connections
        console.log("🔵 WebSocket is already connected. No need to reconnect.");
        return;
    }

    // if (RETRY_COUNT > MAX_RETRIES) { // preventing loop of recoonections
    //     console.warn("⚠ Max retry limit reached. Stopping reconnection.");
    //     return;
    // }

    let socket = null;
    socket = new WebSocket(url);

    socket.onopen = () => {
        console.log("✅ Connected to WebSocket");
        RETRY_COUNT = 0
        UpdateFalkonWebSocketConnection(dispatch, true)
        UpdateFalkonWebSocket(dispatch, socket)
    }

    socket.onmessage = (event) => {

        let History = store.getState().History;

        console.log("📩 Received:", JSON.parse(event.data));

        let data = JSON.parse(event.data);

        if (data.type === "message" && !!History[data.message[0].mp_id]?.length) {
            UpdateHistory(dispatch, data.message[0].mp_id, handleNewSecureChatMessages(History[data.message[0].mp_id], data.message.map(x => mapSecureChatHistoryToConversationModel(x))));
        }

        if (data.type === "message_participant") {
            UpdateSecureChatConversations(dispatch, [mapSecureChatParticipantToConversationCardModel(data.message_participant)]);
        }

        if (data.type === "scheduled_message") {
            UpdateSecureScheduleMessages(dispatch, mapSecureChatSchedulesToConversationMessage(data.scheduled_message[0]))
        }

    };

    socket.onclose = (event) => {

        UpdateFalkonWebSocket(dispatch, null)
        UpdateFalkonWebSocketConnection(dispatch, false)
        console.log("❌ WebSocket Disconnected", event)

        if (event.code === 4001) {
            console.log("Disconnected Manually")
            return;
        }

        const baseDelay = Math.min(1000 * (2 ** RETRY_COUNT), 30000);
        const delay = baseDelay / 2 + Math.random() * (baseDelay / 2);

        setTimeout(() => {
            console.log(`🔄 Reconnecting WebSocket... (Attempt ${RETRY_COUNT + 1})`);
            ConnectWebSocket(dispatch, url);
            RETRY_COUNT++;
        }, delay);

    };

};

export default ConnectWebSocket;
